export default "__VITE_ASSET__Bgid6NsZ__"